import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'app-vertical-line',
	template: ` <div class="vertical-line"></div>`,
	styles: [
		`
			.vertical-line {
				width: 2px;
				height: 100%;
				background-color: #e5e5e5;
				margin: 0 auto;
			}
		`,
	],
})
export class VerticalLineComponent implements OnInit {
	constructor() {}

	ngOnInit(): void {}
}
